

/**
 * Custom hook para manejar haptic feedback usando Capacitor
 * Provee funciones para diferentes tipos de vibración
 */
export const useHaptic = () => {
    const isCapacitorAvailable = typeof window !== 'undefined' &&
        window.Capacitor?.isNativePlatform?.();

    const vibrate = async (duration = 100) => {
        if (!isCapacitorAvailable) {
            // Fallback a Web Vibration API
            if (navigator.vibrate) {
                navigator.vibrate(duration);
            }
            return;
        }

        try {
            const { Haptics, ImpactStyle } = await import('@capacitor/haptics');
            await Haptics.vibrate({ duration });
        } catch (error) {

        }
    };

    const impact = async (style = 'medium') => {
        if (!isCapacitorAvailable) {
            // Fallback pattern
            const patterns = {
                light: 50,
                medium: 100,
                heavy: 200
            };
            if (navigator.vibrate) {
                navigator.vibrate(patterns[style] || 100);
            }
            return;
        }

        try {
            const { Haptics, ImpactStyle } = await import('@capacitor/haptics');
            const styleMap = {
                light: ImpactStyle.Light,
                medium: ImpactStyle.Medium,
                heavy: ImpactStyle.Heavy
            };
            await Haptics.impact({ style: styleMap[style] });
        } catch (error) {

        }
    };

    const notification = async (type = 'success') => {
        if (!isCapacitorAvailable) {
            // Fallback patterns
            const patterns = {
                success: [100, 50, 100],
                warning: [100, 100, 100],
                error: [200, 100, 200, 100, 200]
            };
            if (navigator.vibrate) {
                navigator.vibrate(patterns[type] || [100]);
            }
            return;
        }

        try {
            const { Haptics, NotificationType } = await import('@capacitor/haptics');
            const typeMap = {
                success: NotificationType.Success,
                warning: NotificationType.Warning,
                error: NotificationType.Error
            };
            await Haptics.notification({ type: typeMap[type] });
        } catch (error) {

        }
    };

    return {
        vibrate,
        impact,
        notification
    };
};
